import React from "react";
import { Spin } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import AttachmentTypeGrid from "../../../attachmentType/ui/components/AttachmentTypeGrid";
import { IOrganisationAttachmentTypePresenter } from "../../presenter/OrganisationAttachmentTypePresenter";

export interface Props extends PageProps {}

export interface State extends IOrganisationAttachmentTypePresenter {}

export default class OrganisationAttachmentTypePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      createAttachmentType,
      attachmentTypes,
      contentTypes,
      updateAttachmentType,
      organisationId
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.attachmentTypeLoader}>
            <AttachmentTypeGrid
              organisationId={organisationId}
              translate={translate}
              createAttachmentType={createAttachmentType}
              attachmentTypes={attachmentTypes}
              contentTypes={contentTypes}
              updateAttachmentType={updateAttachmentType}
              organisations={[]}
            />
          </Spin>
        }
      </Page>
    );
  }
}
